import { theEncrypt, theDecrypt } from "./cryptoUtils";

const enc = (text) => theDecrypt(theEncrypt(text));

export const sensitiveWords = {
  "暂无可用链接": enc("暂无可用链接"),
  "加载中...": enc("加载中..."),
  "配置加载失败": enc("配置加载失败"),
  "最新地址": enc("最新地址"),
  "点此进入访问": enc("点此进入访问"),

  "初始化": enc("初始化"),
  "加载资源": enc("加载资源"),
  "准备就绪": enc("准备就绪"),
  "完成": enc("完成"),
  "验证通过，正在进入...": enc("验证通过，正在进入..."),
  "滑动速度过快，请重试": enc("滑动速度过快，请重试"),
  "请滑动到最右侧": enc("请滑动到最右侧"),
  "请匀速滑动验证": enc("请匀速滑动验证"),
  "安全验证": enc("安全验证"),
  "为保障访问安全，请完成以下验证": enc("为保障访问安全，请完成以下验证"),
  "正在加载": enc("正在加载"),
  "正在加载，请稍候...": enc("正在加载，请稍候..."),
  "人机验证": enc("人机验证"),
  "SSL 加密": enc("SSL 加密"),
  "安全防护": enc("安全防护"),
  "隐私保护": enc("隐私保护"),
  "请": enc("请"),
  "向右滑动": enc("向右滑动"),
  "完成人机验证": enc("完成人机验证"),
  "向右滑动验证": enc("向右滑动验证"),

  "链接已失效": enc("链接已失效"),
  "当前访问链接已过期": enc("当前访问链接已过期"),
  "请重新访问主站获取新链接": enc("请重新访问主站获取新链接"),
  "返回主站": enc("返回主站"),
};

export const getSensitiveWord = (key) => sensitiveWords[key] ?? key;

export const replaceSensitiveWord = (text, key) =>
  text.replace(new RegExp(escapeRegExp(key), "g"), sensitiveWords[key]);

export const replaceAllSensitiveWords = (text) => {
  if (text == null || text === "") return "";
  let result = String(text);
  const keys = Object.keys(sensitiveWords).sort((a, b) => b.length - a.length);
  keys.forEach((key) => {
    result = result.replace(
      new RegExp(escapeRegExp(key), "g"),
      sensitiveWords[key]
    );
  });
  return result;
};

/** API 动态文案敏感词替换 */
export const formatApiText = (value) => replaceAllSensitiveWords(value);

function escapeRegExp(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
